export default {
      id: "icon-search-small-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-search-small",
      toString: function () {
        return this.url;
      }
    }